import React, { useCallback } from 'react';
import Link from 'next/link';
import { makeStyles } from '@material-ui/core/styles';
import GridItem from '@/components/material-ui-kit/components/Grid/GridItem';
import Card from '@/components/material-ui-kit/components/Card/Card';
import CardHeader from '@/components/material-ui-kit/components/Card/CardHeader';
import CardBody from '@/components/material-ui-kit/components/Card/CardBody';
import CardFooter from '@/components/material-ui-kit/components/Card/CardFooter';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@/components/common/ui/Button';
import styles from 'styles/jss/original/components/favorites/favoriteMenuListItem';
import classNames from 'classnames';
import { IMenu } from '@/@types/generated/contentful';

// @ts-expect-error
const useStyles = makeStyles(styles);

type ComponentProps = {
  menu: IMenu;
  onRequestUpdateFavorite: (id: string) => void;
  invalid: boolean;
};

const FavoriteMenuListItem: React.FC<ComponentProps> = ({
  menu,
  onRequestUpdateFavorite,
  invalid
}) => {
  const classes = useStyles();
  const handleClick = useCallback(
    (id: string) => {
      onRequestUpdateFavorite(id);
    },
    [onRequestUpdateFavorite]
  );

  return (
    // @ts-expect-error
    <GridItem xs={6} sm={4} md={3} className={classes.flex}>
      <Card product>
        <CardHeader image>
          <Link href={`/menus/${menu.fields.slug}`}>
            <a>
              <picture>
                <source
                  srcSet={`${menu.fields.thumbnail.fields.file.url}?fm=webp`}
                  media='(min-width: 641px)'
                />
                <source
                  srcSet={`${menu.fields.thumbnail.fields.file.url}?fm=webp&fit=pad&w=400`}
                  media='(max-width: 640px)'
                />
                <img
                  src={`${menu.fields.thumbnail.fields.file.url}?fit=pad&w=440`}
                  alt={menu.fields.title}
                />
              </picture>
            </a>
          </Link>
        </CardHeader>
        <CardBody className={classes.cardBody}>
          <Link href={`/menus/${menu.fields.slug}`}>
            <a>
              <h6 className={classNames(classes.cardCategory)}>{menu.fields.cat}</h6>
              <h4 className={classes.cardTitle}>{menu.fields.title}</h4>
            </a>
          </Link>
        </CardBody>
        <CardFooter className={classes.cardFooter}>
          <Tooltip
            id='tooltip-top'
            title='削除する'
            placement='top'
            classes={{ tooltip: classes.tooltip }}
          >
            <Button
              justIcon
              simple
              color='gray'
              disabled={invalid}
              onClick={() => handleClick(menu.fields.id)}
            >
              <i className='fas fa-times' />
            </Button>
          </Tooltip>
        </CardFooter>
      </Card>
    </GridItem>
  );
};

export default FavoriteMenuListItem;
